import React from 'react';
import { Plus } from 'lucide-react';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@roger/ui-components';

interface AddAdministrationRecordButtonProps {
  /** Whether an administration can be recorded right now. */
  canRecord: boolean;
  /** Explanation shown in the popover when recording is blocked. */
  blockedReason: string;
  onAdd: () => void;
}

/**
 * "Add Administration Record" action shown on each medication row.
 *
 * Always visible (so recording is discoverable). When recording is blocked
 * (no visit selected, or the selected visit is signed/completed) the button
 * stays present but, instead of adding, opens a popover explaining why.
 */
const AddAdministrationRecordButton: React.FC<
  AddAdministrationRecordButtonProps
> = ({ canRecord, blockedReason, onAdd }) => {
  if (canRecord) {
    return (
      <Button
        variant='ghost'
        size='sm'
        className='h-7 w-fit px-2 text-xs text-muted-foreground'
        onClick={onAdd}
      >
        <Plus className='h-3.5 w-3.5 mr-1' />
        Add Administration Record
      </Button>
    );
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant='ghost'
          size='sm'
          className='h-7 w-fit px-2 text-xs text-muted-foreground/70'
        >
          <Plus className='h-3.5 w-3.5 mr-1' />
          Add Administration Record
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto max-w-xs p-3 text-sm'>
        {blockedReason}
      </PopoverContent>
    </Popover>
  );
};

export default AddAdministrationRecordButton;
